export const PAGE_TYPE = {
    SIGN_IN: 'SIGN_IN',
    SIGN_UP: 'SIGN_UP',
    TWO_FACTOR_VERIFICATION: 'TWO_FACTOR_VERIFICATION',
    PHONE_NUMBER_VERIFICATION: 'PHONE_NUMBER_VERIFICATION',
    RESET_PASSWORD: 'RESET_PASSWORD',
} as const;

export type PageType = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];

export const VERIFICATION_STATE_TYPE = {
    REQUEST: 'REQUEST',
    VERIFY: 'VERIFY',
} as const;

export type VerificationStateType =
    (typeof VERIFICATION_STATE_TYPE)[keyof typeof VERIFICATION_STATE_TYPE];
